<template>
  <textarea @input="handleChange" class="context-form" rows="1" ref="autosizeTextarea" v-model="changed"></textarea>
</template>

<script>
import autosize from 'autosize'
export default {
  name: 'AutosizeTextarea',
  props: ['value'],
  data () {
    return {
      changedValue: this.value
    }
  },
  computed: {
    changed: {
      get () {
        return this.changedValue
      },
      set (newValue) {
        this.changedValue = newValue
      }
    }
  },
  mounted () {
    autosize(this.$el)
  },
  updated () {
    if (this.value === '') {
      autosize.update(this.$el)
    }
  },
  methods: {
    handleChange (e) {
      this.$emit('input', e.target.value)
    },
    focusComment () {
      this.$refs.autosizeTextarea.focus()
    }
  }
}
</script>
<style scoped>
.input-group > .form-control {
  max-height: 15em;
  overflow: hidden;
}
.image-uploaded{
  color: #20a8d8;
}
.comment-input{
  padding-top: 7px;
}
.context-form {
  padding: 0;
  outline: none;
  border: none;
  resize: none;
  box-shadow: none;
  width: 100%;
  width: fill;
}
.context-form:active,.context-form:focus, .form-control:focus {
  outline: none;
}
.modal-dialog{
  margin: 10% auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AutosizeTextarea.vue